import { render, staticRenderFns } from "./twoLeft.vue?vue&type=template&id=2028ab88&"
import script from "./twoLeft.vue?vue&type=script&lang=js&"
export * from "./twoLeft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports